<div class="d-flex flex-column flex-root app-root" id="kt_app_root">
  <div class="app-page flex-column flex-column-fluid" id="kt_app_page">
    <ng-container *ngIf="appHeaderDisplay">
      <app-header
        id="kt_app_header"
        class="app-header"
        [ngClass]="appHeaderDefaultClass"
      ></app-header>
    </ng-container>

    <div class="app-wrapper flex-column flex-row-fluid" id="kt_app_wrapper">
      <div class="app-main flex-column flex-row-fluid" id="kt_app_main">
        <div class="d-flex flex-column flex-column-fluid">
          <ng-container *ngIf="appToolbarDisplay">
            <app-toolbar
              class="app-toolbar"
              [ngClass]="appToolbarCSSClass"
              id="kt_app_toolbar"
              [appToolbarLayout]="appToolbarLayout"
            ></app-toolbar>
          </ng-container>
          <app-content
            id="kt_app_content"
            class="app-content"
            [ngClass]="contentCSSClasses"
            [contentContainerCSSClass]="contentContainerCSSClass"
            [appContentContainer]="appContentContainer"
            [appContentContainerClass]="appContentContainerClass"
          ></app-content>
        </div>
        <ng-container *ngIf="appFooterDisplay">
          <app-footer
            class="app-footer"
            [ngClass]="appFooterCSSClass"
            id="kt_app_footer"
            [appFooterContainerCSSClass]="appFooterContainerCSSClass"
          ></app-footer>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<app-initialization></app-initialization>
<ng-container>
  <app-scroll-top
    id="kt_scrolltop"
    class="scrolltop"
    data-kt-scrolltop="true"
  ></app-scroll-top>
</ng-container>
<app-messenger-drawer></app-messenger-drawer>
